/** @jsxImportSource @emotion/react */
'use memo'

import { Select } from 'antd'
import React from 'react'
import type { SportGroup } from '../hooks/useFinderSportOptions'

interface Props {
  groups: SportGroup[]
  value: string | undefined
  onChange: (value: string) => void
  disabled?: boolean
  placeholder?: string
}

const filterOption = (
  input: string,
  option?: { label?: unknown; options?: unknown }
) => {
  if (Array.isArray(option?.options)) {
    return false
  }
  return String(option?.label ?? '')
    .toLowerCase()
    .includes(input.toLowerCase())
}

/**
 * Grouped (Full Stats / Basic Stats) sport picker for the finder preference
 * form. Locked (disabled) when editing an existing preference, since the
 * sport is immutable once a listing exists.
 */
const SportSelectField: React.FC<Props> = ({
  groups,
  value,
  onChange,
  disabled = false,
  placeholder,
}) => (
  <Select
    style={{ width: '100%' }}
    options={groups}
    value={value}
    onChange={onChange}
    disabled={disabled}
    placeholder={placeholder}
    showSearch
    filterOption={filterOption}
    // Render the popup inside the field's own container (the modal body) instead
    // of the document body, so it scrolls WITH the modal — otherwise the popup
    // stays pinned to the viewport and "jumps" as the background page scrolls.
    getPopupContainer={(trigger) => trigger.parentElement ?? document.body}
    // Above the profile modal wrapper (10001).
    dropdownStyle={{ zIndex: 10050 }}
  />
)

export default SportSelectField
